import { render, staticRenderFns } from "./registrasi.vue?vue&type=template&id=5e273ce2"
import script from "./registrasi.vue?vue&type=script&lang=js"
export * from "./registrasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports